import BulkUpdaterSubmissionModal from './BulkUpdaterSubmissionModal';

export default BulkUpdaterSubmissionModal;
